//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import hiButton from "../../../components/button/Index";
import { DEVICE } from "../../../store/mutation-types";
import store from "../../../store/index";

export default {
  name: "PayPalConfirmComponent",
  components: { hiButton },
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    // 是否显示已做v-model
    show: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Object,
      required: true,
    },
    payType: {
      type: String,
      default: "paypal",
    },
  },
  computed: {
    isIos() {
      return store.getters[DEVICE] === "ios";
    },
    notSupportCurrency() {
      // 如果遇到不支持的币种则显示特殊样式
      if (this.payType === "paypal" && !this.model.payPalSupportCurrency) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      showModal: this.show,
      en: false, // 是否为英语
    };
  },
  methods: {
    /**
     * 订阅回调
     */
    subscribeClick() {
      this.$emit("subscribe", this.payType);
    },
    /**
     * 点击取消按钮隐藏弹出
     */
    cancel() {
      this.showModal = false;
    },
  },
  watch: {
    showModal(val) {
      this.$emit("updateShow", val);
      if (val) {
        this.errorMsg = "";
        this.inputVal = "";
      }
    },
    show(val) {
      this.showModal = val;
      // 重置设备语言
      this.en = navigator.language.substr(0, 2).toLowerCase() === "en";
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/payment/paypal_confirm/Index.vue